import React, { useContext } from 'react';
import '../styles/ContentStyle.css';
import Button from 'react-bootstrap/Button';
import { Context as MainContext } from '../context/MainContext';

import { Typography } from '@material-ui/core';

const TimeExtension = () => {
  const { state, setAwbState } = useContext(MainContext);
  const onButtonClick = () => {
    setAwbState('CI_R');
  };
  return (
    <div className="ContentContainer">
      <div className="TitleContainer">
        <Typography variant="h5" noWrap>
          Hola {state.awb.consigneeName}
        </Typography>
      </div>
      <div className="MainContentContainer">
        <Typography variant="subtitle1" className="SubtitleText">
          El tiempo para recolectar tu envío dentro del locker ha sido agotado,
          puedes reprogramar ahora o acudir a tienda a recolectar tu envío con
          la atención de un asesor
        </Typography>
        <Button className="Button" onClick={() => onButtonClick()} size="lg">
          REPROGRAMAR VISITA
        </Button>
      </div>
      <div className="AddressContainer">
        <Typography variant="body1">
          {state.station.name}: {state.station.address1}&nbsp;&nbsp;
        </Typography>
        {state.station.google_maps_id ? (
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`https://www.google.com/maps/search/?api=1&query=DHL&query_place_id=${state.station.google_maps_id}`}
          >
            <Typography variant="body1" noWrap>
              Google Maps
            </Typography>
          </a>
        ) : null}
      </div>
      <div className="ThankYouNoteContainer">
        <Typography variant="h5" noWrap>
          ¡Gracias por elegir DHL!
        </Typography>
      </div>
    </div>
  );
};

export default TimeExtension;
